import { render, staticRenderFns } from "./LandingPageRead.vue?vue&type=template&id=1fd4ea6c&scoped=true&"
import script from "./LandingPageRead.vue?vue&type=script&lang=js&"
export * from "./LandingPageRead.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageRead.vue?vue&type=style&index=0&id=1fd4ea6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4ea6c",
  null
  
)

export default component.exports